import React, { useEffect } from "react";

import { useParams, Link } from "react-router-dom"; // Link bileşenini kullanıyoruz

// import faqData from "../../api/faqdata";
import FaqCategory from "../../components/FaqCategory/FaqCategory";
import HeaderTarget from "../../components/HeaderTarget/HeaderTarget";
import FaqContact from "../../components/FaqContact/FaqContact";
import arrowIcon from "./../../assets/arrow.png";
import NotFound from "../NotFound/404";
import { formatPage } from "../../utils/formatPage";
import { useFaqData } from "../../api/useFaqData";
import { useTranslation } from "react-i18next";
import { useSEO } from "../../context/SEOContext";
const FaqCategoryDetail = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("faq.meta.title"),
      description: t("faq.meta.description"),
      keywords: t("faq.meta.keywords"),
      favicon: "/faviconnew.png",
    });
  }, [setSeo, t]);
  const faqData = useFaqData();
  const { category } = useParams(); // URL parametrelerinden kategori alıyoruz

  // Veritabanındaki veriyi formatlanmış kategori ile eşleştiriyoruz
  const categoryData = faqData.find(
    (item) => formatPage(item.text) === category // URL'deki kategori ile eşleşen veriyi buluyoruz
  );
  // Eğer kategori verisi bulunamazsa, hata mesajı gösteriyoruz
  if (!categoryData) {
    return <NotFound />;
  }

  return (
    <>
      <HeaderTarget activePage="faq" />
      <section className="bgcolorpage pt-4 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 mb-4 mt-5">
              <a href="./faq">
                <img
                  src={arrowIcon}
                  alt="arrowIcon"
                  width={20}
                  className="mb-3"
                />
              </a>
            </div>
            <div className="col-lg-7 mb-3">
              <div className="bg-white w-100">
                <h5 className="fw-light p-4 pb-1 bg-white text-start">
                  {t(categoryData.textKey)}
                </h5>
                <hr className="mb-0" />
                <div className="row p-4 fw-14">
                  {categoryData.faqs.map((faq, index) => (
                    <Link
                      key={index} // Her eleman için key ekliyoruz
                      to={`/faq/${formatPage(categoryData.text)}/${faq.id}`}
                      className={`text-dark fw-light ${
                        index !== categoryData.faqs.length - 1
                          ? "border-bottom"
                          : ""
                      }`}
                      style={{ padding: 15 }}
                    >
                      {faq.question}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="bg-white text-center w-100">
                <h5 className="fw-light p-4 pb-1 bg-white text-start">
                  {t("THEMES")}
                </h5>
                <hr className="mb-0" />
                <div className="row g-0 align-items-center">
                  <FaqCategory />
                </div>
              </div>
              <div className="bg-white w-100 mt-3">
                <div className="row g-0 align-items-center">
                  <FaqContact />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqCategoryDetail;
